export enum ActionTypes {
  showWelcomerModal = 'showWelcomerModal',
  hideWelcomerModal = 'hideWelcomerModal'
}

export const showWelcomerModal = () => ({
  type: ActionTypes.showWelcomerModal,
  showWelcomerModal: true
});

export const hideWelcomerModal = () => ({
  type: ActionTypes.hideWelcomerModal,
  showWelcomerModal: false
});

export type Actions = ReturnType<typeof showWelcomerModal>;
